import {
  dimensiondata_1_tetelek_group_w200_row,
  dimensiondata_2_termekek_group_1_2_3_column,
  kilo_tonna_value_1_data_precision1,
  year_column_expanded,
  month_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviOlajMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviOlajMerleg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column_expanded,
      month_column,
      ...dimensiondata_2_termekek_group_1_2_3_column,
      kilo_tonna_value_1_data_precision1,
      order_1,
      order_2,
    ],
  },
};
